import React from "react";
import { HeadingM, ParagraphS } from "@tumomento/ui";
import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "gatsby";
import "./CategorySection.scss";

export type CategorySectionProps = {
  categoryName: string;
  articles: Pick<
    Queries.ContentfulBlogPost,
    "urlSlug" | "title" | "publishDate" | "heroImage"
  >[];
};

export const CategorySection = ({
  categoryName,
  articles,
}: CategorySectionProps) => {
  return (
    <section className="flex col w100 mb-6 g-4 justify-between category-section content-layout">
      <div className="flex row justify-between">
        <HeadingM>{categoryName}</HeadingM>
        <Link
          className="flex row align-center chip-view-all"
          to={`/${categoryName.toLowerCase().replaceAll(/\s/g, "-")}`}
        >
          <ParagraphS typography="body-s-semibold">
            Ver todos los artículos
          </ParagraphS>
          <svg
            width="7"
            height="13"
            viewBox="0 0 7 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.78759 1L6.02539 6.3335L0.787591 11.667"
              stroke="#18C9B4"
              strokeWidth="1.33337"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
      <Swiper
        className="flex row w100"
        spaceBetween={16}
        slidesPerView={"auto"}
        breakpoints={{ 720: { spaceBetween: 48 } }}
      >
        {articles.slice(0, 4).map((art, i) => (
          <SwiperSlide
            key={`${i}-${art.title}`}
            className="category-article-card-slide"
          >
            <CategoryArticleCard {...art} />
          </SwiperSlide>
        ))}
      </Swiper>
      {/* <div className="flex row justify-between g-4">
        {articles.slice(0, 4).map((art, i) => (
          <CategoryArticleCard {...art} key={`${i}-${art.title}`} />
        ))}
      </div> */}
    </section>
  );
};

export const CategoryArticleCard = ({
  heroImage,
  publishDate,
  title,
  urlSlug,
  category = undefined,
}: CategorySectionProps["articles"][number] & {
  category?: string;
}) => {
  const publish = (() => {
    const result = format(parseISO(publishDate ?? ""), "MMM d, yyyy", {
      locale: es,
    });
    return result.charAt(0).toUpperCase() + result.slice(1);
  })();
  return (
    <Link className="flex col g-2 category-article-card" to={`/${urlSlug}`}>
      <div className="image-container">
        <img
          src={heroImage?.url ?? ""}
          alt={heroImage?.title ?? ""}
          width={224}
          height={139}
        />
        {!!category ? (
          <div className="go-badge flex center-content">
            <ParagraphS typography="body-s-semibold" color="green2">
              {category}
            </ParagraphS>
          </div>
        ) : (
          <div className="go-icon flex center-content">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.65527 12.1431L10.5928 8.20557L6.65527 4.26807"
                stroke="white"
                strokeWidth="1.89258"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
      </div>
      <p className="title">{title}</p>
      <p className="publish">{publish}</p>
    </Link>
  );
};
